"use client";

import { type ReactElement } from "react";
import {
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
} from "../..";
import { useTranslations, useLocale } from "use-intl";
import type { Locale } from "../../i18n/config.ts";

function PortalLocaleSwitcher(): ReactElement {
  const locale: Locale = useLocale() as Locale;
  const t = useTranslations("global.UserMenu");

  const handleChange = async (value: string): Promise<void> => {
    window.location.replace(`https://data.oreme.org/langue/change/${value}`);
  };

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger>{t("language")}</DropdownMenuSubTrigger>
      <DropdownMenuPortal>
        <DropdownMenuSubContent className="font-inter">
          <DropdownMenuRadioGroup
            onValueChange={(value) => void handleChange(value)}
            value={locale}
          >
            <DropdownMenuRadioItem value="fr">Français</DropdownMenuRadioItem>
            <DropdownMenuRadioItem value="en">English</DropdownMenuRadioItem>
          </DropdownMenuRadioGroup>
        </DropdownMenuSubContent>
      </DropdownMenuPortal>
    </DropdownMenuSub>
  );
}

export { PortalLocaleSwitcher };
